import React from "react";
import { Wrapper } from "../styles/components/Global/Global";
import { SceneContainer, Scene } from "../styles/components/Global/Global";

const Footer = () => {
  return (
    <Wrapper>
      <SceneContainer id="lotus-footer">
        <Scene className="scene" />
      </SceneContainer>
    </Wrapper>
  );
};

export default Footer;
